export default "__VITE_ASSET__7920dd35__"